<template>
    <div>
        <header class="d-flex justify-content-around align-items-center">
            <img style="max-width: 190px;" src="@/img/logo.png" />
            <h1>onOffice Aste Immobiliari</h1>
        </header>
        <div class="container pt-4">
            <div class="content">
                <h3>Che cos'è</h3>
                <p>onOffice Aste Immobiliari è il servizio che consente alla tua agenzia di rimanere sempre aggiornati sulle aste immobiliari.</p>
                
                <h3 class="mt-3">Features</h3>
                <ul>
                    <li>Sfoglia la lista delle aste</li>
                    <li>Seleziona quelle che ti interessano</li>
                    <li>Crea gli immobili su onOffice con un click</li>
                </ul>
                
                <h3 class="mt-3">Come funziona</h3>
                <p>
                    Il servizio è gratuito ed è disponibile esclusivamente per gli utenti onOffice. Si attiva attraverso il marketplace interno.
                    <br/>
                    Una volta attivato il servizio troverai la lista filtrabile delle aste attualmente presenti. Potrai visualizzare la scheda completa e poi selezionare l'asta desiderata per importarla in onOffice.
                </p>
                
                <h3 class="mt-3">Il fornitore dei dati</h3>
                <p>
                    I dettagli delle aste immobiliari sono serviti da <a href="https://wikicasa.it" target="_blank">wikicasa.it</a>
                </p>
            </div>
        </div>
        <footer class="py-2" style="background-color: #80acd3; color: white;">
            <div class="container">

                <div>
                    "onOffice Aste Immobiliari" è un servizio sviluppato per onOffice Italia Srl © 2025 <a href="https://it.onoffice.com/" target="_blank">https://it.onoffice.com/</a>
                </div>
                <div>
                </div>
            </div>
        </footer>
    </div>
</template>